import axios from "axios";
import { clearAuthSession, TOKEN_KEY } from "../lib/authStorage";

export const http = axios.create({
  baseURL: process.env.REACT_APP_NODE_ENV === "local"
    ? `http://localhost:${process.env.REACT_APP_BACK_PORT}/api`
    : `https://${process.env.REACT_APP_API_URL}/api`
});

http.interceptors.request.use(
  function (request) {
    const token = localStorage.getItem(TOKEN_KEY);

    if (!token) {
      clearAuthSession();
    }

    request.headers["Authorization"] = `Bearer ${token}`;

    return request;
  },

  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    if (error?.response?.status === 403) {
      window.location.href = "/login";
      clearAuthSession();
    }
    return Promise.reject(error);
  }
);
